var _circle, _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "dynamic-box__list-svg-circle",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#3CC8F4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_929_750",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.04822 11.011L13.2988 4.75977L14.261 5.72129L7.04822 12.934L2.7207 8.60653L3.68222 7.64501L7.04822 11.011Z",
    fill: "#FFFFFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04822 11.011L13.2988 4.75977L14.261 5.72129L7.04822 12.934L2.7207 8.60653L3.68222 7.64501L7.04822 11.011Z",
    fill: "#3CC8F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04822 11.011L4.9269 13.1323C5.48953 13.695 6.25263 14.011 7.04831 14.011C7.84398 14.011 8.60706 13.6949 9.16966 13.1322L7.04822 11.011ZM13.2988 4.75977L15.4194 2.63769C14.2476 1.46678 12.3486 1.46717 11.1773 2.63856L13.2988 4.75977ZM14.261 5.72129L16.3823 7.84261C16.945 7.27987 17.2611 6.51659 17.261 5.72075C17.2608 4.92492 16.9445 4.16175 16.3816 3.59921L14.261 5.72129ZM7.04822 12.934L4.9269 15.0554C6.09848 16.2269 7.99797 16.2269 9.16954 15.0554L7.04822 12.934ZM2.7207 8.60653L0.599383 6.4852C0.0367739 7.04781 -0.279297 7.81088 -0.279297 8.60652C-0.279297 9.40217 0.0367734 10.1652 0.599383 10.7278L2.7207 8.60653ZM3.68222 7.64501L5.80354 5.52369C4.63197 4.35211 2.73248 4.35211 1.5609 5.52368L3.68222 7.64501ZM9.16966 13.1322L15.4202 6.88097L11.1773 2.63856L4.92679 8.8898L9.16966 13.1322ZM11.1782 6.88184L12.1404 7.84336L16.3816 3.59921L15.4194 2.63769L11.1782 6.88184ZM12.1397 3.59997L4.9269 10.8127L9.16954 15.0554L16.3823 7.84261L12.1397 3.59997ZM9.16954 10.8127L4.84202 6.48521L0.599383 10.7278L4.9269 15.0554L9.16954 10.8127ZM4.84202 10.7278L5.80354 9.76633L1.5609 5.52368L0.599383 6.4852L4.84202 10.7278ZM1.5609 9.76633L4.9269 13.1323L9.16954 8.88969L5.80354 5.52369L1.5609 9.76633Z",
    fill: "#FFFFFF",
    mask: "url(#path-2-inside-1_929_750)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBlue);
export default __webpack_public_path__ + "static/media/RightBlue.76f2cd0a5aa015ef8bd2e06aa0aa75ec.svg";
export { ForwardRef as ReactComponent };